<div [ngClass]="{ 'has-edit-button': isEditMode }">
  <!-- New create/edit button -->
  <ng-container
    *ngIf="isEditMode"
    [brManageContentButton]="document"
    documentTemplateQuery="new-Code-document"
    folderTemplateQuery="new-Code-folder"
    parameter="document"
    [relative]="false"
    root=""
  >
  </ng-container>

  <!-- Show Content-->
  <div
    *ngIf="document && content"
    [edsSpacing]="marginBottom === 'auto' ? 'xl' : marginBottom"
  >
    <eds-dynamic-block
      [preTitle]="content?.title.preTitle"
      [title]="content?.title.title"
      [description]="content?.summary?.content"
      [theme]="cardTheme"
      [footerNoteLabel]="content?.footnote?.value"
      [ctaButton]="ctaButton"
    >
      <div dynamicBody *ngFor="let card of content?.htmlCards">
        <eds-dynamic-card
          [hasShadows]="hasPanelShadow"
          [hasMediaLeft]="card.hasMediaLeft"
          [imageClass]="card.imageClass"
          [cardImageSrc]="card.imagePath"
          [title]="card.title.title"
          [preTitle]="card.title?.preTitle"
          [bodyContent]="card.cardContent?.value"
          [linkText]="card.link?.displayText"
          [url]="card.link?.href"
          [signInRequired]="card.link?.signInLink | ftIsSignInRequired | async"
          [signInCustomIntro]="card.link?.signInIntroTextLabel"
          [signInCustomContentText]="card.link?.signInContentTextLabel"
          [hideLockIcon]="card.link?.hideLockIcon"
          [signInTooltip]="'common.locked-link-tooltip' | translate"
          [isNewWindow]="card.link?.target === '_blank'"
          [externalLink]="card.link?.external"
          [optionalLink]="card.optionallink !== null"
          [optionalLinkText]="card.optionallink?.displayText"
          [optionalLinkUrl]="card.optionallink?.href"
          [optionalLinkIsNewWindow]="card.optionallink?.target === '_blank'"
          [optionalLinkExternalLink]="card.optionallink?.external"
          [optionalLinkSignInRequired]="
            card.optionallink?.signInLink | ftIsSignInRequired | async
          "
          [optionalLinkSignInCustomIntro]="
            card.optionallink?.signInIntroTextLabel
          "
          [optionalLinkSignInCustomContentText]="
            card.optionallink?.signInContentTextLabel
          "
          [optionalLinkHideLockIcon]="card.optionallink?.hideLockIcon"
          [optionalLinkTheme]="card.optionalButtonTheme"
          [theme]="cardTheme"
          (linkClick)="setDownloadLocation(card.link?.downloadLocation)"
          (optionalLinkClick)="
            setDownloadLocation(card.optionallink?.downloadLocation)
          "
          [widenParams]="card.widenParams"
          [trackDownload]="card.link?.enableDownloadTracking"
        ></eds-dynamic-card>
      </div>
    </eds-dynamic-block>
  </div>

  <div
    *ngIf="!document && isEditMode"
    edsGrid
    class="no-document no-document__component"
  >
    <div class="no-document__overlay">
      Click to configure <strong>Dynamic Cards</strong>
    </div>
  </div>
</div>
